import NotFound from '../components/ErrorPages/NotFound'
import ServerError from '../components/ErrorPages/ServerError'
import Welcome from '@/components/Pages/Welcome'
import AboutUs from '@/components/Pages/AboutUs'
import CustomPage from '@/components/Pages/CustomPage'
import ContactUs from '@/components/Pages/ContactUs'
import ResetPassword from '@/components/Login/ResetPassword'
import EcommerceRoutes from './ecommerce_router'
import GoOrderRoutes from './goorder_router'
// profile start
import Profile from '@/components/Blocks/ProfileMenu'
import OnGoingOrders from '@/components/Collections/Order/OnGoingOrders'
import ScheduledOrders from '@/components/Collections/Order/ScheduledOrders'
import OrderDetails from '@/components/Collections/Order/OrderDetails'
import OrderHistory from '@/components/Collections/History/OrderHistory'
import ChangeProfile from '@/components/Blocks/ProfileInfo/ChangeProfile'
import History from '@/components/Blocks/ProfileInfo/History'
import Wallet from '@/components/Blocks/ProfileInfo/Wallet'
import MobilePersonalInformation from '@/components/Blocks/MobileProfileMenu/MobilePersonalInformation'
import MobileLoyalty from '@/components/Blocks/MobileProfileMenu/MobileLoyalty'
import HowToUseLoyalty from '@/components/Blocks/MobileProfileMenu/HowToUseLoyalty'
import SavedCards from '@/components/Blocks/ProfileInfo/SavedCards'
import Notifications from '@/components/Blocks/ProfileInfo/Notifications'
import Addresses from '@/components/Blocks/ProfileInfo/Addresses'
import StoresList from '../components/Blocks/StoresList'
import Example from '@/components/Pages/Example'
import Help from '@/components/Pages/Help'
import Offers from '@/components/Pages/Offers'
import Terms from '@/components/StaticPages/StaticTermsAndConditions'
import Privacy from '@/components/StaticPages/StaticPrivacyPolicy'
import FAQ from '@/components/Pages/FAQ'
import HowItWorks from '@/components/Pages/HowItWorks'
import MobileWallet from '@/components/Blocks/MobileProfileMenu/MobileWallet'
import MobileSavedCard from '@/components/Blocks/MobileProfileMenu/MobileSavedCard'
import EmailConfirmation from '@/components/Pages/EmailConfirmation'
import PartnerWithUs from '@/components/Pages/PartnerWithUs'
import Catalog from '@/components/Pages/Catalog'

// profile end

var routes = [
  {
    path: '/404',
    name: '404',
    component: NotFound,
    meta: {
      data: {},
      title: 'Page not found',
    },
  },
  {
    path: '/500',
    name: '500',
    component: ServerError,
    meta: {
      data: {},
      title: 'Internal server error',
    },
  },
  {
    path: '/',
    name: 'home',
    component: Welcome,
    meta: {
      title: 'Go order',
      metaTags: [
        {
          name: 'description',
          content: 'Go orders: online deliver food',
        },
        {
          property: 'og:description',
          content: 'Go orders: online deliver food.',
        },
      ],
    },
  },
  {
    path: '/example',
    name: 'example',
    component: Example,
  },
  {
    path: '/page/:page_slug',
    name: 'to_page',
    component: CustomPage,
    meta: {
      data: {},
      title: 'Custom page',
    },
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: AboutUs,
    meta: {
      data: {},
      title: 'About us',
    },
  },

  {
    path: '/help',
    name: 'help',
    component: Help,
    meta: {
      data: {},
      title: 'Help',
    },
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQ,
    meta: {
      data: {},
      title: 'FAQ',
    },
  },
  {
    path: '/how_it_work',
    name: 'how_it_work',
    component: HowItWorks,
    meta: {
      data: {},
      title: 'How it works',
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms,
    meta: {
      title: 'Terms',
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: {
      title: 'Privacy policy',
    },
  },
  {
    path: '/reset_password/:token',
    name: 'reset_password',
    component: ResetPassword,
    meta: {
      data: {},
    },
  },
  {
    path: '/confirm/:brand/:email/:token',
    name: 'email_verification_brand',
    component: EmailConfirmation,
    meta: {
      title: 'Email confirmation',
    },
  },
  {
    path: '/partner-with-us',
    name: 'partner_with_us',
    component: PartnerWithUs,
    meta: {
      title: 'Partner with us',
    },
  },
  {
    path: '/confirm/:email/:token',
    name: 'email_verification',
    component: EmailConfirmation,
  },
  {
    path: '/contact_us',
    name: 'contact_us',
    component: ContactUs,
    meta: {
      title: 'Contact us',
    },
  },
  {
    path: '/brands/:brand_id',
    name: 'brand_page',
    component: StoresList,
    meta: {
      title: 'Brand page',
    },
  },
  {
    path: '/offers',
    name: 'offers',
    component: Offers,
    meta: {
      title: 'Offers',
    },
  },
  {
    path: '/profile',
    component: Profile,
    name: 'profile',
    redirect: '/personal-info',
    meta: {
      title: 'Personal Info',
    },
    children: [
      {
        path: '/personal-info',
        name: 'profile.personal-info',
        component: ChangeProfile,
        meta: { authRequired: true, title: 'Profile' },
      },
      {
        path: '/ongoing-orders',
        name: 'profile.ongoing-orders',
        component: OnGoingOrders,
        meta: { authRequired: true, title: 'Ongoing orders' },
      },
      {
        path: '/scheduled-orders',
        name: 'profile.scheduled-orders',
        component: ScheduledOrders,
        meta: { authRequired: true, title: 'Scheduled orders' },
      },
      {
        path: '/order/:brand_id/:store_id/:order_id',
        name: 'profile.order',
        component: OrderDetails,
        meta: { authRequired: true, title: 'Order details' },
      },
      {
        path: '/history',
        name: 'profile.history',
        component: History,
        meta: { authRequired: true, title: 'Past orders' },
      },
      {
        path: '/order-history/:brand_id/:store_id/:order_id',
        name: 'profile.order-history',
        component: OrderHistory,
        meta: { authRequired: true, title: 'Order history' },
      },
      {
        path: '/wallet',
        name: 'profile.wallet',
        component: Wallet,
        meta: { authRequired: true, title: 'Wallet' },
      },
      {
        path: '/saved-cards',
        name: 'profile.saved-cards',
        component: SavedCards,
        meta: { authRequired: true, title: 'Saved cards' },
      },
      {
        path: '/notifications',
        name: 'profile.notifications',
        component: Notifications,
        meta: { authRequired: true, title: 'Notifications' },
      },
      {
        path: '/addresses',
        name: 'profile.addresses',
        component: Addresses,
        meta: { authRequired: true, title: 'Address' },
      },
    ],
  },
  {
    path: '/mobile_profile',
    name: 'mobile_profile',
    component: MobilePersonalInformation,
    meta: { authRequired: true, title: 'Profile' },
  },
  {
    path: '/mobile-loyalty',
    name: 'mobile-loyalty',
    component: MobileLoyalty,
    meta: { authRequired: true, title: 'Mobile loyalty' },
  },

  {
    path: '/mobile-saved-cards',
    name: 'mobile-saved-cards',
    component: MobileSavedCard,
    meta: { authRequired: true, title: 'Saved cards' },
  },
  {
    path: '/mobile_wallet',
    name: 'mobile_wallet',
    component: MobileWallet,
    meta: { authRequired: true, title: 'Wallet' },
  },
  {
    path: '/mobile_loyalty_usage',
    name: 'mobile_loyalty_usage',
    component: HowToUseLoyalty,
    meta: {
      title: 'How to use Loyalty',
    },
  },
  {
    path: '/:brand_id/:store_id/:floor_id/:table_id/dinein',
    name: 'dine_in_items_selection',
    component: Catalog,
    meta: {
      data: {},
      title: 'Catalog',
    },
  },
  {
    path: '/:brand_id/:store_id/:order_id/updateorder',
    name: 'dine_in_add_to_order',
    component: Catalog,
    meta: {
      data: {},
      title: 'Catalog',
    },
  },
  {
    path: '*',
    redirect: '/404',
    meta: {
      title: 'Not found',
    },
  },
]
// let ecommerce_routes = EcommerceRoutes
// let go_order_routes = GoOrderRoutes
routes = routes.concat(EcommerceRoutes)
routes = routes.concat(GoOrderRoutes)
export default routes
